import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { PagerData } from '../../../business-entities/PagerData';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { AppointmentService } from '../../../business-services/appointment.service';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BrandService } from '../../../business-services/brand.service';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { CustomerPickDropService } from '../../../business-services/customer-pick-drop.service';
import { CustomerPickDropViewModel } from '../../../business-entities/customer-pick-drop-view-model';
import { AppointmentStatus, WorkOrderStatus } from '../../../business-entities/appointmentStatus-model';
import {PickDropCustomer} from '../../../business-entities/pick-drop-customer';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { BrandViewModel } from '../../../business-entities/brand-view-model';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { AppointmentStatusRequestModel } from '../../../business-entities/appointmentList-model';
import { DatePipe } from '@angular/common';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { AdminCommonService } from '../../../services/admin-common.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-customer-drop',
  templateUrl: './customer-drop.component.html',
})
export class CustomerDropComponent implements OnInit {
  searchTerm: string;
  totalCount: number=0;
  isAdvanceSearch: any;
  selectedStatus: number;
  selectedDealer:any;
  bookingDate: any[] = [];
  createdDate: any[] = [];
  dealers: DealerViewModel[] = [];
  workOrderStatusList: WorkOrderStatus[];
  isTodayViewOn: boolean;
  isWeekViewOn: boolean;
  weekViewDate:any;
  todayViewDate: any;
  dealerList: DealerViewModel[];
  dealerlist: Array<SelectListItemViewModel>;
  customerPickDropExcel: any;
  todayDate=new Date();
  pickupDropoffList: any = [];
  pager: any = {};
  pagerData: PagerData = {
    page: 1,
    pagerSize: Constant.GridPagerSize,
  };
  appointmentStatusRequestModel: AppointmentStatusRequestModel = {
    bookingDate: null,
    createdDate: null,
    dealerId: null,
    serviceAdvisorId:null,
    mechanicId:null,
    appointmentStatusId: null,
    workOrderStatusId: null,
    customerName: null,
    languageCode: null,
    licensePlate: null,
    mobileNumber: null,
    woNumber: null
  };
  appointmentstatusList: AppointmentStatus[];
  PickDropList: CustomerPickDropViewModel[] = [];
  CustomerPickDropListPdf: any;
  dateRequestmodel :any={};
  brandList: BrandViewModel[];
  CustomerVehiclePickDropResponse : CustomerPickDropViewModel[]=[];
  CustomerVehiclePickDropDocumentResponse : CustomerPickDropViewModel[]=[];
  CustomerVehiclePickDropList : CustomerPickDropViewModel[]=[];
  filterList :PickDropCustomer[]=[];
  CustomerPickDropData = {
  sortColumn:'',
  sortDirection:'',
  StartRecordNumber :0,
  DealerId :'',
  BookingDate:'',
  BookingFrom:'',
  ToBooking:'',
  BookingFromDate:'',
  BookingToDate:'',
  FromCreatedDate:'',
  ToCreatedDate:'',
  createdDate:'',
  PageSize :25,
  LanguageCode :'',
  AppointmentStatusId :0,
  WorkOrderStatusId :0,
  SearchTerm :'',
  IsForDocuments :false,
  UserId :'',
  }
  throttle = 100;
  scrollDistance = 1;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private spinner: NgxSpinnerService,
    private customerPickdropService: CustomerPickDropService,
    private appointmentService: AppointmentService,
    public dealerBusinessService: DealerBusinessService,
    private brandService: BrandService,
    private excelService: ExcelService,
    private cookieservice: CookieService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private _eref: ElementRef,
    private adminCommonSer :AdminCommonService
    ) { }

  ngOnInit(): void {
    this.getUserDealers();
    this.getBrands().then(() => {
      let language = this.cookieservice.get('userSelectedLanguage');
      this.GetAllWorkOrderStatus(language);
    });
    this.getCustomerPickDropList();
    if (this.customerPickdropService.filterTypeId == Constant.TodayView) {
      this.loadTodayView();
    } else if (this.customerPickdropService.filterTypeId == Constant.WeekView) {
      this.loadWeekView();
    } else {
      this.CustomerPickDropData.BookingDate = null;
    }
  }

  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }

  onQuickSerch() {
    this.CustomerPickDropData.SearchTerm = this.searchTerm;
    this.spinner.show();
    this.CustomerVehiclePickDropResponse=[];
    this.getCustomerPickDropList();
  }

  onSearch() {
    this.isAdvanceSearch = true;
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }

  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
  }
  loadTodayView() {
    this.isTodayViewOn = true;
    this.isWeekViewOn = false;
    let todays_date = new Date();
    this.weekViewDate = this.datePipe.transform(todays_date, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(todays_date, 'dd/MM/yyyy');
    this.bookingDate=[];
    this.bookingDate.push(todays_date);
    this.bookingDate.push(todays_date);
    this.todayViewDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.CustomerPickDropData.BookingDate = this.todayViewDate;
    this.CustomerPickDropData.StartRecordNumber = 0;
    this.PickDropList = [];
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    this.CustomerVehiclePickDropResponse=[];
    this.getCustomerPickDropList();
  }

  loadWeekView() {
    this.isTodayViewOn = false;
    this.isWeekViewOn = true;
    let current = new Date();
    let startDay = 1; //0=sunday, 1=monday etc.
    let d = current.getDay(); //get the current day
    let weekStart = new Date(current.valueOf() - (d <= 0 ? 7 - startDay : d - startDay) * 86400000); //rewind to start day
    let weekEnd = new Date(weekStart.valueOf() + 6 * 86400000); //add 6 days to get last day
    this.weekViewDate = this.datePipe.transform(weekStart, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(weekEnd, 'dd/MM/yyyy');
    this.bookingDate=[];
    this.bookingDate.push(weekStart);
    this.bookingDate.push(weekEnd);
    this.CustomerPickDropData.BookingDate = this.weekViewDate;
    this.spinner.show();
    this.CustomerVehiclePickDropResponse=[];
    this.getCustomerPickDropList();
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.CustomerPickDropData.sortColumn = column;
    this.CustomerPickDropData.sortDirection = direction;
    this.CustomerPickDropData.StartRecordNumber = 0;
    this.spinner.show();
    this.CustomerVehiclePickDropResponse=[];
    this.getCustomerPickDropList();
  }
  refresh() {
    this.CustomerVehiclePickDropResponse=[];
    this.getCustomerPickDropList();
  }
  async setPage(pagerData: PagerData) {
    if (
      pagerData == null ||
      pagerData === undefined ||
      pagerData.page < 1 ||
      pagerData.page > this.pager.totalPages
    ) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
  }

  onDealerChange(dealerId:string)
  {
    this.CustomerPickDropData.DealerId = dealerId;
    this.CustomerPickDropData.StartRecordNumber = 0;
    this.spinner.show();
    this.CustomerVehiclePickDropResponse=[];
    this.getCustomerPickDropList();
    this.spinner.hide();
  }

  public getBrands(): Promise<void> {
    return new Promise((resolve, _reject) => {
      this.brandService.getBrand().then((res) => {
        if (res) {
          this.brandList = res;
        }
        resolve();
      });
    });
  }
  getCustomerPickDropListForDocument(type){
    this.CustomerPickDropData.IsForDocuments = true;
    this.spinner.show();
    this.customerPickdropService.getCustomerCustomerPickDrop(this.CustomerPickDropData).then(
      (res) => {
       if (res == null) {
         this.spinner.hide();
       }
        this.CustomerVehiclePickDropDocumentResponse = this.CustomerpickDropExelDataMapper(res);
        if(type === Enums.DocumentsType.Pdf)
        {
          this.cdr.detectChanges();
          if (this.CustomerVehiclePickDropDocumentResponse && this.CustomerVehiclePickDropDocumentResponse.length > 0) {
            this.spinner.show();
            this.cdr.detectChanges();
            const doc = new jsPDF();
            autoTable(doc, { html: '#customerPdf', margin: { top: 3, left: 3, right: 3, bottom: 3 }, styles: { fontSize: 8 }, columnStyles: { 0: { cellWidth: 9 }, 5: { cellWidth: 25 }, 6: { cellWidth: 15 }, 8: { cellWidth: 22 } } });
            doc.save('customersPickDropList_af.pdf');
            this.spinner.hide();
          }
        }
        if(type === Enums.DocumentsType.Excel)
        {
          this.excelService.exportAsExcelFile(this.CustomerVehiclePickDropDocumentResponse, 'customersPickDropList_af');
        }
       this.CustomerPickDropData.IsForDocuments = false;
        this.spinner.hide();
     }
   );
  }

  private CustomerpickDropExelDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.No = index + 1;
        single.WoStatus = element.workOrderStatus;
        single.RegistrationNo = element.licensePlate;
        single.RegistrationNo = element.licensePlate;
        single.WoNo = element.workOrderNo;
        single.CustomerName = element.customerName;
        single.MobileCode = element.mobileCode;
        single.MobilNo = +element.mobileCode + ' ' + element.mobileNo;
        single.DealerName = element.dealerName;
        single.CustomerPickUpTime = element.pickupTime;
        single.DropOffTime =element.dropOffTime
        single.AppointmentDate = element.bookedDate;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  public async exportAsXLSX(_excel: number) {
    this.getCustomerPickDropListForDocument(_excel);
  }
  public async onDownloadPDF(_pdf: number) {
    this.cdr.detectChanges();
    this.getCustomerPickDropListForDocument(_pdf);
  }

  private dataMapper(customerWaitingResponse:PickDropCustomer[]) {
    return customerWaitingResponse.map((element, i) => {
      return {

         row : 1 + i,
         appointmentStatus:element.appointmentStatus,
         appointmentStatusColor:element.appointmentStatusColor,
         bookedDate :element.bookedDate,
         bookedDateTime:element.bookedDateTime,
         brandCode :element.brandCode,
         brandName :element.brandName,
         createdDate :element.createdDate,
         createdDateTime :element.createdDateTime,
         customerName :element.customerName,
         dealerId :element.dealerId,
         dealerName :element.dealerName,
         id :element.id,
         mobileCode : element.mobileCode,
         mobileNo: element.mobileNo,
        modelName: element.modelName,
        openingHours: element.openingHours,
        totalCount: element.totalCount,
        workOrderNo: element.workOrderNo,
        workOrderStatusColor: element.workOrderStatusColor,
        workOrderStatusId: element.workOrderStatusId,
      } as PickDropCustomer
    });
  }
  getBrandImage(key: any) {
    return this.brandList?.filter(
      (x) => x.brandCode.toUpperCase() === key.toUpperCase()
    )[0];
  }
  async getUserDealers() {
    await this.dealerBusinessService
      .getUserDealersDropdown()
      .then((response) => {
        this.dealerList = this.mapdealer(response.userDealersModel);
        this.dealers = this.mapDealerListToDealers(response.userDealersModel);
      });
  }

  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{ 
        let single = Object();
        single.value = element.dealerId;
        single.text = element.dealerName;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  mapDealerListToDealers(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{ 
        let single = Object();
        single.dealerId = element.dealerId;
        single.name = element.dealerName;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onClose() {
    this.onReset();
    this.isAdvanceSearch = false;
  }
  onReset() {
    this.CustomerPickDropData.AppointmentStatusId = null;
    this.CustomerPickDropData.WorkOrderStatusId = null;
    this.CustomerPickDropData.BookingDate = null;
    this.CustomerPickDropData.createdDate = null;
    this.bookingDate = [];
    this.createdDate = [];
  }

  AdvanceSearchSubmit(_event:any) {
    this.CustomerVehiclePickDropResponse=[];
    if(this.CustomerPickDropData.BookingFromDate && this.CustomerPickDropData.BookingToDate)
    {
      const bookingdate = this.datePipe.transform(new Date(this.CustomerPickDropData.BookingFromDate), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(this.CustomerPickDropData.BookingToDate), 'dd/MM/yyyy');
      this.CustomerPickDropData.BookingDate = bookingdate;
    }
    if(this.CustomerPickDropData.FromCreatedDate && this.CustomerPickDropData.ToCreatedDate)
    {
      const createdate = this.datePipe.transform(new Date(this.CustomerPickDropData.FromCreatedDate), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(this.CustomerPickDropData.ToCreatedDate), 'dd/MM/yyyy');
      this.CustomerPickDropData.createdDate = createdate;
    }
    this.getCustomerPickDropList();
    this.isAdvanceSearch = false;
  }

   onChange(event:any)
  {
    if (event) {
      if(event.beginJsDate != null){
        const startDate = new Date(event.beginJsDate);
        this.CustomerPickDropData.BookingFromDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1).toISOString();
      }
      if(event.beginJsDate != null){
        const endDate = new Date(event.endJsDate);
        this.CustomerPickDropData.BookingToDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1).toISOString();
      }
      if(event.beginJsDate != null){
        const startDate = new Date(event.beginJsDate);
        this.CustomerPickDropData.FromCreatedDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1).toISOString();
      }
      if(event.beginJsDate != null){
        const startDate = new Date(event.beginJsDate);
        this.CustomerPickDropData.ToCreatedDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1).toISOString();
      }
      this.CustomerPickDropData.StartRecordNumber = 0;
    }
  }
  onStatusChange(status:any){
    if (status == undefined) {
      this.CustomerPickDropData.WorkOrderStatusId = Enums.WOStatus.All;
    } else {
      this.CustomerPickDropData.WorkOrderStatusId = status;
    }
    this.CustomerPickDropData.StartRecordNumber = 0;
    this.spinner.show();
    this.CustomerVehiclePickDropResponse=[];
    this.getCustomerPickDropList();
    this.spinner.hide();
  }

  GetAllWorkOrderStatus(languageCode, fromIntialize: boolean = false) {
    this.spinner.show();
    this.appointmentStatusRequestModel.appointmentStatusId = this.appointmentService.appointmentRequestModel.appointmentStatusId;
    this.appointmentStatusRequestModel.workOrderStatusId = this.appointmentService.appointmentRequestModel.workOrderStatusId;
    this.appointmentStatusRequestModel.dealerId = this.appointmentService.appointmentRequestModel.dealerId;
    this.appointmentStatusRequestModel.languageCode = languageCode;
    this.appointmentStatusRequestModel.licensePlate = this.appointmentService.appointmentRequestModel.licensePlate;
    this.appointmentStatusRequestModel.woNumber = this.appointmentService.appointmentRequestModel.woNumber;
    this.appointmentStatusRequestModel.customerName = this.appointmentService.appointmentRequestModel.customerName;
    this.appointmentStatusRequestModel.mobileNumber = this.appointmentService.appointmentRequestModel.mobileNumber;
    if (fromIntialize) {
      this.appointmentStatusRequestModel.bookingDate = this.appointmentService.appointmentRequestModel.bookingDate;
    }
    else {
      this.appointmentStatusRequestModel.bookingDate = this.getFormattedDate(this.bookingDate);
      this.appointmentStatusRequestModel.createdDate = this.getFormattedDate(this.createdDate);
    }

    this.appointmentService.GetAllWorkOrderStatus(this.appointmentStatusRequestModel).then(data => {
      this.workOrderStatusList = data.responseObject.workOrderStatusList;
      this.appointmentstatusList = data.responseObject.appointmentStatusList;
    })
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.filterList.length) {
      this.CustomerPickDropData.StartRecordNumber = this.CustomerVehiclePickDropResponse.length
      this.getCustomerPickDropList();
    }
  }

  async getCustomerPickDropList() {
     this.spinner.show();
    this.customerPickdropService.getCustomerCustomerPickDrop(this.CustomerPickDropData).then(
       (res) => {
        if (res == null) {
          this.spinner.hide();
        }
         this.totalCount=0;
         this.filterList.push(...this.dataMapper(res));
          this.CustomerVehiclePickDropResponse.push(...res)
        if(this.CustomerVehiclePickDropResponse.length>0){
          this.totalCount = this.CustomerVehiclePickDropResponse[0].totalCount;
        }
         this.spinner.hide();
      }
    );
  }
  
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
  }
